import React from 'react';
import GeneralTabs from '../application/general-tabs/GeneralTabs';

export default (props) => <GeneralTabs {...props} />;
